import styled from 'styled-components'

export const СurrentAll = styled.div `display: flex;
align-items: center;
justify-content: center;`
export const СurrentArrow = styled.div `color: aqua;`
export const СurrentText = styled.div `font-style: normal;
font-weight: 400;
font-size: 12px;
line-height: 14px;

text-align: center;
letter-spacing: 0.04em;

color: rgba(199, 204, 220, 0.5);`
export const СurrentMonth = styled.p `font-family: 'Roboto';
font-style: normal;
font-weight: 700;
font-size: 14px;
line-height: 16px;
letter-spacing: 0.02em;
text-transform: uppercase;


color: #F6F7FB;`